__turbopack_context__.v({
  "className": "robotomedium_3b69b23b-module__dVxumq__className",
  "variable": "robotomedium_3b69b23b-module__dVxumq__variable",
});
